import ModalDialog from "../../modal-dialog";
import React from "react";
import { Button } from "mesh-component-library";
import styled from "@emotion/styled";

const ChatReminderModalStyled = styled.div`
  .c-modal-dialog__content {
    height: fit-content;
  }
  .c-modal-dialog__header {
    border: none;
  }
  .l-grid {
    justify-content: center;
  }
`;

export const ChatClosureReminderModal = ({ openModal, toggleModal }) => {
  return (
    <ChatReminderModalStyled className="chat-closure-container">
      <ModalDialog
        id="chat-closure-reminder-modal"
        className="chat-closure-reminder-modal"
        title={
          <div className={"u-align-center"}>
            End your chat session before submitting your request.
          </div>
        }
        hideTrigger
        showCloseBtn={false}
        isActive={openModal}
      >
        <div className="l-grid">
          <div
            data-dd-privacy="mask"
            className="l-grid__col l-grid__col--11 plate-text-container"
          >
            Open your chat session and click the “X” in the upper-right corner
            to end.
          </div>
          <div
            className="l-grid__col l-grid__col--6 button-group"
            data-dd-privacy="allow"
          >
            <Button
              shape="pill"
              isPrimary
              onClick={toggleModal}
              utils={{
                hrLeft: "md",
              }}
            >
              open chat
            </Button>
          </div>
        </div>
      </ModalDialog>
    </ChatReminderModalStyled>
  );
};
